import dayjs from '@/helpers/dayjs';

export default {
  install: (app) => {
    app.config.globalProperties.$dayjs = dayjs;
  },
};
